<div class="overflow-auto">
    <div class="float-left">
     <!-- <h2 class="title">{{ 'AGREEMENT_CREDITS.Step.' + data.type | translate }}</h2>-->
      <h2 >{{ 'AGREEMENT_CREDITS.Step.registeredCreator' | translate }}: {{ data.legalName }}</h2>
    </div>
    <button class="btn btn-secondary float-right" (click)="goToRegistrationReport()">{{ 'AGREEMENT_CREDITS.Step.viewRegistrationReport' | translate }}</button>
  </div>
  